import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ItemInventoryCodeComponent } from "./item-inventory-code.component";

@NgModule({
  declarations: [ItemInventoryCodeComponent],
  imports: [CommonModule],
  exports: [ItemInventoryCodeComponent],
})
export class ItemInventoryCodeModule {}
